import SkeletonType2 from "@/app/components/ui/Skeletons/Type2";
import { useSendPaymentLinkToUserAPI } from "@/app/hooks/api_hooks/bookings/useSendPaymentLinkToUserAPI";
import { useUserBookingsWhatsappScriptDetailsAPI } from "@/app/hooks/api_hooks/bookings/useUserBookingsWhatsappScriptDetailsAPI";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import WhatsappTemplatePreviewModal from "@/app/components/ui/WhatsappTemplatePreviewModal";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";

const SendWhatsappScriptimport = ({ setOpen, open, bookingId, petName, clientId, petId }: any) => {
  const { execute: fetchUserdetails, userDetails } = useUserBookingsWhatsappScriptDetailsAPI();
  const { execute: senWhatsappTouser } = useSendPaymentLinkToUserAPI();
  const { execute: logClick } = useClickLogAPI();
  const vmsUserId = useAppSelector((state) => state.auth?.user?.email);

  const [loader, setLoader] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);

  useEffect(() => {
    if (bookingId) {
      setLoader(true);
      fetchUserdetails(bookingId).then(({ status }) => {
        if (status) {
          setLoader(false);
        }
      });
    }
  }, [bookingId]);

  if (loader) {
    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="z-50 fixed inset-0 overflow-y-auto"
          onClose={() => setOpen(false)}
        >
          <div className="sm:block flex justify-center items-end px-4 sm:p-0 pt-4 pb-20 min-h-screen text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="sm:inline-block hidden sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white shadow-xl sm:my-8 p-[16px] rounded-[12px] max-w-[516px] w-full text-left transform transition-all sm:align-middle">
                <SkeletonType2 />
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    );
  }

  return (
    <WhatsappTemplatePreviewModal
      open={open}
      onClose={() => setOpen(false)}
      title="Resend Payment Link"
      initialMobile={userDetails?.phone_number ?? ""}
      script={userDetails?.whatsapp_text ?? ""}
      isSending={isSending}
      onSend={(mobile) => {
        setIsSending(true);
        logClick({
          event_type: "WHATSAPP_PAYMENT_LINK_SENT",
          scr_id: "BOOKING_PREVIEW",
          client_id: clientId,
          pet_id: petId,
          vms_user_id: vmsUserId,
          phone: mobile,
          timestamp: Date.now(),
          filter_values: { booking_id: bookingId ?? null, pet_name: petName ?? null },
        });
        senWhatsappTouser(bookingId, mobile).then(({ status }) => {
          setIsSending(false);
          if (status) {
            setOpen(false);
          }
        });
      }}
      onCancel={() => setOpen(false)}
    />
  );
};

export default SendWhatsappScriptimport;
